import { motion } from "framer-motion";
import { SectionHeading } from "./SectionHeading";

const clients: { file: string; width: number; height: number }[] = [
  { file: "afs.png", width: 480, height: 120 },
  { file: "aneurin-bevan.png", width: 480, height: 120 },
  { file: "awen.png", width: 480, height: 190 },
  { file: "fairer-gwent.png", width: 480, height: 177 },
  { file: "memoria.png", width: 480, height: 138 },
  { file: "open-university.png", width: 357, height: 252 },
  { file: "sinclairs-law.png", width: 480, height: 72 },
  { file: "v12.png", width: 480, height: 203 },
  { file: "watkins-_-gunn.png", width: 480, height: 54 },
  { file: "de-novo.png", width: 96, height: 26 },
  { file: "credas.png", width: 332, height: 152 },
  { file: "robertsons.png", width: 480, height: 141 },
  { file: "utilita-arena.png", width: 466, height: 200 },
  { file: "cardiff-vale-credit-union.png", width: 165, height: 77 },
];

export function ClientsMarquee() {
  const baseUrl = import.meta.env.BASE_URL;
  const track = [...clients, ...clients];

  return (
    <section className="py-24 border-t border-b border-white/5 overflow-hidden bg-black relative">
      {/* Heading */}
      <div className="container mx-auto px-6 mb-14">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <SectionHeading align="center" fullUnderline>Brands that trust Black Swan</SectionHeading>
        </motion.div>
      </div>

      {/* Marquee with edge fade mask */}
      <div
        className="relative flex w-full"
        style={{
          maskImage: "linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)",
          WebkitMaskImage: "linear-gradient(to right, transparent, #000 8%, #000 92%, transparent)",
        }}
      >
        <div
          className="flex shrink-0 items-center animate-marquee"
          style={{ "--marquee-duration": "32s" } as React.CSSProperties}
        >
          {track.map((client, idx) => (
            <div
              key={idx}
              className="group flex-shrink-0 flex items-center justify-center h-28 w-52 md:w-60 mr-6 md:mr-8 p-6 rounded-xl border border-white/5 bg-white/[0.02] transition-all duration-500 hover:border-primary/30 hover:bg-white/[0.04] hover:-translate-y-1"
            >
              <img loading="lazy" decoding="async"
                src={`${baseUrl}clients/${client.file}`}
                width={client.width}
                height={client.height}
                alt={`${client.file.replace(/\.png$/, "").replace(/[-_]+/g, " ").trim()} logo`}
                className="h-8 md:h-10 w-auto max-w-[85%] object-contain brightness-0 invert opacity-80 transition-all duration-500 group-hover:filter-none group-hover:opacity-100 group-hover:scale-110"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
